import React from "react";
import { Link } from "react-router";

export default function MyProfileLink() {
  return (
    <Link to="/profile" id="my-profile-link">
      My Profile
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/components/navigation/topbar/my-profile-link.js